import { render, staticRenderFns } from "./MenuLeft.vue?vue&type=template&id=51cb0f36&scoped=true"
import script from "./MenuLeft.vue?vue&type=script&lang=js"
export * from "./MenuLeft.vue?vue&type=script&lang=js"
import style0 from "./MenuLeft.vue?vue&type=style&index=0&id=51cb0f36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cb0f36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cb0f36')) {
      api.createRecord('51cb0f36', component.options)
    } else {
      api.reload('51cb0f36', component.options)
    }
    module.hot.accept("./MenuLeft.vue?vue&type=template&id=51cb0f36&scoped=true", function () {
      api.rerender('51cb0f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuLeft.vue"
export default component.exports